import script from "./SocialFundRequestDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./SocialFundRequestDetail.vue?vue&type=script&setup=true&lang=js"

import "./SocialFundRequestDetail.vue?vue&type=style&index=0&id=26f5d2fb&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26f5d2fb"]])

export default __exports__